/* VicHoorn: "Complete sua composição" acompanha a variante escolhida na PDP.
 * - A variante vem do input[name="id"] do formulário principal: é o que vai ao
 *   carrinho, e o product-info do tema dispara "change" nele a cada troca de opção
 *   (vazio quando a combinação não existe). Mesmo padrão do vh-product-sticky.js.
 * - Regra, igual à do Liquid em snippets/vh-composicao.liquid:
 *     sem variante válida e à venda → nenhum card com o preço da oferta;
 *     fora da seleção → todos os cards;
 *     PDP de uma joia da seleção → só o card cujo maior preço à venda
 *     (data-comp-pmax) não passa do preço da variante escolhida.
 * - Só liga/desliga ([hidden]) o que o Liquid já renderizou: não calcula nem
 *   formata preço, e não mexe no formulário (haste e anodização ficam intactas).
 */
if (!customElements.get('vh-composicao-oferta')) {
  customElements.define(
    'vh-composicao-oferta',
    class VhComposicaoOferta extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.vh-composicao');
        this.inSelection = this.dataset.inSelection === 'true';
        this.variants = this._readVariants();
        this._onChange = this._onChange.bind(this);
        this._schedule = this._schedule.bind(this);
        document.addEventListener('change', this._onChange, true);
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && !this._unsubscribe) {
          this._unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this._schedule);
        }
        this._sync();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this._onChange, true);
        clearTimeout(this._timer);
        if (this._unsubscribe) {
          this._unsubscribe();
          this._unsubscribe = null;
        }
      }

      _readVariants() {
        const script = this.querySelector('script[type="application/json"]');
        try {
          return JSON.parse(script ? script.textContent : '[]');
        } catch (_) {
          return [];
        }
      }

      _form() {
        const byId = this.dataset.form ? document.getElementById(this.dataset.form) : null;
        if (byId) return byId;
        const info = this.closest('product-info');
        return info ? info.querySelector('product-form form[action$="/cart/add"]') : null;
      }

      _onChange(event) {
        const target = event.target;
        if (!target || target.name !== 'id') return;
        const form = this._form();
        if (form && (target.form === form || form.contains(target))) this._schedule();
      }

      _schedule() {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this._sync(), 0);
      }

      _sync() {
        if (!this.section) return;
        const form = this._form();
        const input = form ? form.querySelector('input[name="id"]') : null;
        const id = input ? String(input.value) : '';
        const variant = id ? this.variants.find((item) => String(item.id) === id) : null;
        const valid = Boolean(variant && variant.available);

        this.section.querySelectorAll('.vh-composicao__item[data-comp-pmax]').forEach((item) => {
          const max = Number(item.dataset.compPmax);
          const on = valid && (!this.inSelection || (Number.isFinite(max) && max <= variant.price));
          item.querySelectorAll('[data-comp-promo]').forEach((el) => {
            el.hidden = !on;
          });
          item.querySelectorAll('[data-comp-regular]').forEach((el) => {
            el.hidden = on;
          });
        });
      }
    }
  );
}
